import React from 'react';
import ActionIconButton from './ActionIconButton';

const DeleteButton = ({title = 'Excluir', ...props}) => (
    <ActionIconButton variant="delete" title={title} {...props}/>
);

export default DeleteButton;
